import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { borderRadius } from '@mui/system';
import {
  TextField,
  Grid,
  Switch,
  FormControlLabel,
  FormGroup,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  FormHelperText,
} from '@mui/material';
import axios from 'axios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { notify } from '../../common/functions/react-toastify.function';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import apiClient from '../../common/functions/api_axios_instance.function';
import { validateAndPreventSpecialChars } from '../../common/functions/text_field_validation.function.js';
import {} from '@mui/material';
import { PocTypes } from '../../enums/soilTypes.enum';
import { useAtom } from 'jotai';
import { editRoute, selectedRouteOnMap } from '../../common/atom/atoms';
import { updateRouteName } from '../Kmz/functions/update_route_name.function';
import Swal from 'sweetalert2';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 413,
  bgcolor: 'background.paper',
  borderRadius: '5px',
  //   boxShadow: 24,
  p: 4,
};

export default function PocEstimationModalCost(props) {
  const { open, handleClose, setRouteName, handleLockRoute, routeName, getAllRoutes } = props;
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const [selectedRoute, setSelectedRoute] = useAtom(selectedRouteOnMap);
  const [ediRouteModal, setEditRoute] = useAtom(editRoute);
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Add validation to prevent special characters and problematic patterns
    if (validateAndPreventSpecialChars(value, 'Route Name')) {
      setRouteName(value);
    } else {
      // Prevent the input by reverting to previous value
      e.target.value = routeName;
    }
  };

  const handleCloseModal = () => {
    handleClose();
    setRouteName('');
    setEditRoute(false);
    setSelectedRoute(null);
  };
  useEffect(() => {
    if (selectedRoute?.routeName) {
      setRouteName(selectedRoute.routeName);
    }
  }, [selectedRoute]);

  const handleSubmitPoc = () => {
    if (!routeName) {
      notify('error', 'Add route name first');
      return;
    } else {
      showBackdrop();
      handleLockRoute();
      hideBackdrop();
      handleCloseModal();
    }
  };
  const handleUpdate = async () => {
    const obj = { routeName: routeName };
    if (!routeName) {
      notify('error', 'Add route name first');
      return;
    }
    showBackdrop();
    const resp = await updateRouteName(selectedRoute?.id, obj);
    resp && notify('success', 'Route Updated Successfully');
    hideBackdrop();
    handleCloseModal();
    getAllRoutes();
  };
  return (
    <div>
      <Modal
        open={open || ediRouteModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            style={{
              // fontFamily: 'Roboto',
              fontSize: '24px',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 'normal',
            }}
          >
            Fiber Route Name
          </Typography>
          <Grid container spacing={2} paddingTop={'20px'}>
            <Grid item xs={12}>
              <TextField
                id="standard-basic"
                required
                value={routeName || ''}
                onChange={handleChange}
                name="name"
                label="route name"
                variant="outlined"
                sx={{ width: '350px' }}
              />
            </Grid>

            <Grid container spacing={2} style={{ marginLeft: '11px', marginTop: '20px' }}>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  // disabled={routeName ? false : true}
                  sx={{
                    backgroundColor: '#BD1D23',
                    width: '160px',
                    '&:hover': {
                      backgroundColor: '#BD1D23',
                    },
                    '&:disabled': {
                      backgroundColor: '#E57373',
                      color: '#fff',
                    },
                  }}
                  onClick={selectedRoute?.routeName ? handleUpdate : handleSubmitPoc}
                >
                  {selectedRoute?.routeName ? 'Update' : 'Submit'}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  sx={{
                    color: '#000',
                    backgroundColor: 'white',
                    width: '160px',
                    '&:hover': {
                      borderColor: '#BD1D23',
                      backgroundColor: 'rgba(189, 29, 35, 0.1)',
                    },
                  }}
                  onClick={() => handleCloseModal()}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
